import React, { useState } from 'react'

import Navigation from './navigation'
import RankCard from './rank-card'

import * as S from './styles'

import { Ranks } from '../../enums/ranks.enum'

import IProps from './props'

type RankKeys = keyof typeof Ranks

const Ranking = ({ rankingData }: IProps) => {
  const [currentRank, setCurrentRank] = useState<Ranks>(Ranks.Especialidade)

  const handleNavigate = (name: string) => {
    setCurrentRank(Ranks[name as RankKeys])
  }

  const currentRankData = rankingData[currentRank]

  const renderRankCards = () => currentRankData.map((item, index) => (
    <RankCard {...item} position={index + 1} key={item.id} />
  ))

  return (
    <S.Container>
      <S.Header>
        <S.Title>Mais procurados na plataforma</S.Title>
        <S.Subtitle>Escolha um item para visualizar o ranking</S.Subtitle>
      </S.Header>
      <Navigation onNavigate={handleNavigate} />
      <S.CardList>{renderRankCards()}</S.CardList>
    </S.Container>
  )
}

export default Ranking
